import React from 'react';
import { Gutter, ParagraphHeader, Well } from '@axiom/ui';
import type { Candidate, CandidateRedux, Taxonomy } from '@axiom/validation';

import { TalentProfileDetailCompensationSection } from './TalentProfileDetailCompensationSection';

export interface TalentProfileDetailCompensationProps {
  talent: CandidateRedux | Candidate;
  taxonomy: Taxonomy;
  name: string;
}

export const TalentProfileDetailCompensation: React.FC<
  TalentProfileDetailCompensationProps
> = ({ talent, taxonomy, name }) => {
  return (
    <Well background="gray" name={name}>
      <ParagraphHeader name="TALENT_COMPENSATION_HEADER">
        Compensation
      </ParagraphHeader>
      <Gutter bottom="16px" />
      {talent.currencyType ? (
        <TalentProfileDetailCompensationSection
          currencyCode={talent.currencyType}
          talent={talent}
          taxonomy={taxonomy}
        />
      ) : null}
    </Well>
  );
};
